var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m48.54 30.16 22.2 27.519-13.08 12.924-27.52-22.2.037.309a58 58 0 0 1-.591-8.286c0-1.671.069-3.324.195-4.743l-5.64-5.601-8.76 3.759L.14 21.16l14.4-3.6 3.039-3.279L21.3.001l12.759 15.24-4 9.279 5.317 5.317a59 59 0 0 1 5.184-.229c2.814 0 5.583.201 7.98.552zm33.764 40.042c1.28 1.119.8 3.6-1.08 5.439l14.64 14.679-5.64 5.679-14.64-14.679c-1.84 1.761-4.24 2.241-5.32.96l-5-5.679-1.12-.921 11.68-11.679.8 1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarts);
export default __webpack_public_path__ + "static/media/darts.e41a75c4121463e97580f5e5ca2a96b7.svg";
export { ForwardRef as ReactComponent };